import { render } from "./UzhnetButtonDanger.vue?vue&type=template&id=d13137ac&scoped=true"
import script from "./UzhnetButtonDanger.vue?vue&type=script&lang=js"
export * from "./UzhnetButtonDanger.vue?vue&type=script&lang=js"

import "./UzhnetButtonDanger.vue?vue&type=style&index=0&id=d13137ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d13137ac"]])

export default __exports__